import React from 'react';

const Object_Destructuring = () => {
  return (
    <div >
      <h1>Object_Destructuring</h1>
      <p>Placeholder component for: "Object Destructuring"</p>
    </div>
  );
};

export default Object_Destructuring;
